import { render, staticRenderFns } from "./Pagina-no-encontra.vue?vue&type=template&id=9ec76980&"
import script from "./Pagina-no-encontra.vue?vue&type=script&lang=js&"
export * from "./Pagina-no-encontra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports